import chalk from 'chalk';

let _jsonMode = false;

export function setJsonMode(enabled: boolean): void {
  _jsonMode = enabled;
  if (enabled) {
    chalk.level = 0;
  }
}

export function isJsonMode(): boolean {
  return _jsonMode;
}

/**
 * Emit a JSON object to stdout and exit cleanly.
 * In JSON mode, this is the only output function that should be used.
 */
export function jsonOutput(data: Record<string, unknown>): void {
  console.log(JSON.stringify(data, null, 2));
}
